<template>
<master-layout pageTitle="Not Enough Permissions">
  <div class="center-align">
    <div class="section_404_img">
      <img src="@/resources/images/404_not_found.svg" alt="not_found">
    </div>
    <div class="not-found-content">
      <h2 class="not-found-title ion-no-margin">You don't have permission to view this page</h2>
      <p class="not-found-subtitle ion-no-margin">
        Please contact your admin, or go back to the
        <a class="not-found-link" @click="goToDashboard">Home</a> page.
      </p>
    </div>
  </div>
</master-layout>
</template>

<script>
export default {
  methods: {
    goToDashboard() {
      this.$router.push('/dashboard');
    }
  }
}
</script>

<style scoped>
.center-align {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.section_404_img {
  width: 60vw;
  max-width: 480px;
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: center;
}
.section_404_img img {
  width: 100%;
  height: auto;
  display: block;
}
.not-found-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 12px;
  margin-top: 20px;
  max-width: 480px;
  padding: 0 20px;
}
.not-found-title {
  font-size: 20px;
  font-weight: 600;
  color: var(--black);
}
.not-found-subtitle {
  font-size: 14px;
  color: var(--gray-04);
  line-height: 20px;
}
.not-found-link {
  color: var(--purple);
  font-weight: 500;
  cursor: pointer;
  text-decoration: underline;
}
.not-found-link:hover {
  opacity: 0.85;
}
</style>
